var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('price-input',{ref:"input",attrs:{"name":(_vm.name + "Price"),"label":_vm.$t('WIZARD.CHANGE_IN_VALUE'),"value":_vm.value,"parse-to-number":true,"custom-rules":_vm.customRules},on:{"input":_vm.handleInputEvent,"blur":_vm.handleBlurEvent}})}
var staticRenderFns = []

export { render, staticRenderFns }